import { formatPhoneNumberIntl } from "react-phone-number-input";
export const jsonObj = (values, dialCode, dialCodeBP) => {
    const primaryContactParsed = extractDialCodeAndNumber(dialCode);
    const businessPhoneParsed = extractDialCodeAndNumber(dialCodeBP);

    const jsonObj = {
        "businessName": values.businessName,
        "type": values.type.value,
        "emailAddress": values.email,
        "mobile": parseInt(businessPhoneParsed.phoneNumber),
        "dialcode": businessPhoneParsed.dialCode,
        "websiteHref": values.websiteLink,
        "addressLine1": values.Address,
        "addressLine2": values.addressLine2,
        "country": values.country.value,
        "state": values.state.value,
        "city": values.city.value,
        "zipcode": values.zipCode.toString(),
        "isSSOUser": values.isSSOUser,
        "primaryContact": {
            "firstName": values.firstName,
            "lastName": values.lastName,
            "emailAddress": values.email1,
            "mobile": parseInt(primaryContactParsed.phoneNumber),
            "dialcode": primaryContactParsed.dialCode
        },
        "partnerUser": {
            "username": values.userName,
            "userRole": values.userRole.value
        },
        "characteristic": values.attributeList
    };

    return jsonObj;
};

export const editJsonObj = (values,dialCode, dialCodeBP) => {
    const primaryContactParsed = extractDialCodeAndNumber(dialCode);
    const businessPhoneParsed = extractDialCodeAndNumber(dialCodeBP);
    const editJsonObj = {
        "businessName": values.businessName,
        "type": values.type.value,
        "emailAddress": values.email,
        "mobile": parseInt(businessPhoneParsed.phoneNumber),
        "dialcode": businessPhoneParsed.dialCode,
        "websiteHref": values.websiteLink,
        "addressLine1": values.Address,
        "addressLine2": values.addressLine2,
        "country": values.country.value,
        "state": values.state.value,
        "city": values.city.value,
        "zipcode": (values.zipCode).toString(),
        "isSSOUser": values.isSSOUser,
        "primaryContact": {
            "id": values.id,
            "firstName": values.firstName,
            "lastName": values.lastName,
            "emailAddress": values.email1,
            "mobile": parseInt(primaryContactParsed.phoneNumber),
            "dialcode": primaryContactParsed.dialCode
        },
        "characteristic": values.attributeList
    };
    return editJsonObj;
};

export const UserRoleOptions = [
    { value: 'ISPPartnerAdmin', label: 'ISP Partner Admin' },
];

export const TypeOptions = [
    { value: 'reseller', label: 'reseller' },
];

const extractDialCodeAndNumber = (rawDialCode) => {
    const phoneNumber = formatPhoneNumberIntl(rawDialCode);
    const dialCodeWithPlus = phoneNumber.match(/^\+\d+(\s|$)/)[0].trim();
    const restOfNumber = phoneNumber.slice(dialCodeWithPlus.length).replace(/\s/g, '');
    return {
        dialCode: dialCodeWithPlus.replace(/\s/g, ''),
        phoneNumber: restOfNumber
    };
};